/* eslint-disable react-hooks/exhaustive-deps */
import { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { executeLogout, modalShow } from '../../store/actions';
import BankIdVerificationModal from './BankIdVerificationModal';
import { createAuthenticationUrl } from '../../utils';

const BankIdVerificationContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('authentication');

  const handleStartButton = (): void => {
    window.location.href = createAuthenticationUrl(undefined, true);
  };

  const openBankIdVerificationModal = () => {
    dispatch(
      modalShow(
        t('BankIdVerification.modalTitle'),
        t('BankIdVerification.startButton'),
        t('BankIdVerification.logoutButton'),
        () => {
          // Start Step-up authentication flow
          handleStartButton();
        },
        () => {
          dispatch(executeLogout());
        },
        <BankIdVerificationModal />,
      ),
    );
  };

  useEffect(() => {
    openBankIdVerificationModal();
  }, [dispatch, openBankIdVerificationModal]);

  return <></>;
};

export default BankIdVerificationContainer;
